import { request } from "@/interface/helper";

const str = "missionAvatarFrame";

export const missionAvatarFrame = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/mission/frame/list" }),
    add: (data) => request({ data, method: "post", url: "/mission/frame/add" }),
    detail: (data) => request({ data, method: "post", url: "/mission/frame/detail" }),
    edit: (data) => request({ data, method: "post", url: "/mission/frame/modify" }),
  },
};
